module.exports = __webpack_public_path__ + "static/media/showVideo.12c74f8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/index/showVideo.mp4
// module id = mg51
// module chunks = 1